import { IdAndName } from "@/api/IdAndName";

export const boardUserName = (users: ReadonlyArray<IdAndName>, userId?: number | null): string => {
  if (!userId) {
    return "";
  }
  return users.find(user => user.id === userId)?.name ?? `User #${userId}`;
};

export const boardUserOptions = (users: ReadonlyArray<IdAndName>) =>
  users.map(user => ({ value: user.id, label: user.name }));
